module.exports = __webpack_public_path__ + "media/src/images/thumb_org_avatar_placeholder-8beb341e05181d0f5eca0a534dd54fb0.svg";